module.exports = __webpack_public_path__ + "img/giftcard_details.4bbfd283.svg";